import useSessionStore from 'Context/useSessionStore'
import { PERMISSION_BY_ROLE } from 'Utils/permissionByRol'
import { useState } from 'react'
import DeleteAccountModal from './DeleteAccountModal'

const DangerZoneSettings = () => {
  const { user } = useSessionStore((state) => ({ user: state.user }))
  const [showDeleteModal, setShowDeleteModal] = useState(false)

  const canDeleteAccount = PERMISSION_BY_ROLE.SETTINGS.DELETE_ACCOUNT.includes(user?.role)

  if (!canDeleteAccount) { return null }

  return (
    <>
      <hr className="m-0" />

      <div className="settings_card">
        <div className="settings_card_body">
          <h6 className="fw-bold mb-1">Danger zone</h6>
          <p className="m-0">Be careful. Account deletion cannot be undone.</p>
        </div>
        <div className="settings_card_footer d-flex justify-content-end">
          <button type="button" className="btn btn-outline-danger" onClick={() => setShowDeleteModal(true)}>
            Delete account
          </button>
        </div>

        {showDeleteModal && (
          <DeleteAccountModal companyName={user?.company?.name} onClose={() => setShowDeleteModal(false)} />
        )}
      </div>
    </>
  )
}

export default DangerZoneSettings
